import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

type TLandingBubbleProps = {
	children: ReactNode;
	className?: string;
	contentClassName?: string;
};

/**
 * Landing-owned bubble frame. Do not use the rebrand `Bubble` primitive here —
 * its ghost variant forces transparent backgrounds and zero padding on
 * `[data-slot=bubble-content]`, and Next's CSS order lets that win over the
 * landing glass/teal recipes.
 */
export function LandingBubble({ children, className, contentClassName }: TLandingBubbleProps) {
	return (
		<div className={cn("w-fit max-w-full min-w-0", className)}>
			<div className={cn("h-auto w-fit max-w-full min-w-0 overflow-hidden", contentClassName)}>{children}</div>
		</div>
	);
}
